import React from "react";
import { STATUS_META } from "@/lib/data";

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.en_attente;
  return (
    <span
      data-testid={`status-${status}`}
      className="text-[11px] font-semibold px-3 py-1 rounded-full inline-block"
      style={{ color: m.color, background: m.bg }}
    >
      {m.label}
    </span>
  );
}

export function BookingCard({ b, children }) {
  return (
    <div data-testid="booking-item" className="p-5 rounded-2xl border border-white/10 bg-[#121216]">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-xl text-white">{b.artist_name}</h3>
          <p className="text-[#C9A24B] text-sm">{b.event_type}</p>
        </div>
        <StatusBadge status={b.status} />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 text-sm">
        <Info label="Date" value={b.event_date} />
        <Info label="Lieu" value={`${b.city}, ${b.country}`} />
        <Info label="Invités" value={b.guest_count || "—"} />
        <Info label="Budget" value={b.budget_estimate || "Sur devis"} />
      </div>
      {b.message && <p className="text-[#A19E95] text-sm mt-3 italic">« {b.message} »</p>}
      {b.response_message && (
        <div className="mt-3 p-3 rounded-lg bg-[#C9A24B]/10 border border-[#C9A24B]/20 text-sm text-[#E5D9B8]">
          <span className="text-[#C9A24B] font-semibold">Réponse : </span>{b.response_message}
        </div>
      )}
      {children}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-[#6E6B63]">{label}</div>
      <div className="text-[#D8D5CD]">{value}</div>
    </div>
  );
}
